import { useEffect, useState } from "react";
import Loader from '../General/Loader';
import { useWizard } from "../../Contexts/WizardContext";
import { getDealTCM, updateDealAndCreateQuote } from "../../api/endpoints";
import { Button } from "../General/Button";
import { XCircle } from "lucide-react";

const defaultPackage = 'rest_easy'

export default function PackageSelectionTCM() {
    const {formData, previousStep } = useWizard()
    const dealId = formData.dealId
    // const dealId = '29068989078'

    const [packages, setPackages] = useState([
        {
            id: 'kick_back',
            billing: {
                monthly: {
                    summer: 0,
                    winter: 0
                },
                prepayment: {
                    summer: 0,
                    winter: 0
                }
            },
            name: "Kick Back",
            icon: "🌿",
            summer_features: ["Mowing", "Line Trimming", "Edging", "Access to Enhancement Services"],
            winter_features: [
              '3" Threshold',
              "Coverage For All Storms",
              "Discounted One-Off Rates",
              "Prompt Service",
              "Full Coverage",
            ]
        },
        {
            id: 'rest_easy',
            name: "Rest Easy",
            billing: {
                monthly: {
                    summer: 0,
                    winter: 0
                },
                prepayment: {
                    summer: 0,
                    winter: 0
                }
            },
            icon: "⭐",
            badge: "Most Popular",
            summer_features: [
              "Includes all of the services in Kick Back",
              "Spring & Fall Aerations (2x)",
              "Fertilizations (3x)",
              "Revive Applications (3x)",
              "Fall Overseed",
              "Sprinkler Activation",
              "Sprinkler Winterization",
              "$5 Discount Per Man Hour On Irrigation Services",
            ],
            winter_features: [
              'Kick Back winter maintenance add-on options',
              '2" Threshold',
            ]
        },
        {
            id: 'total_freedom',
            name: 'Total Freedom',
            billing: {
                monthly: {
                    summer: 0,
                    winter: 0
                },
                prepayment: {
                    summer: 0,
                    winter: 0
                }
            },
            icon: "👑",
            summer_features: [
              "Includes all of the services in Kick Back & Rest Easy",
              "Sprinkler Audits & Seasonal Adjustments (2x)",
              "Premium Double Pass Aeration",
              "Additional Fertilization (+1)",
              "Additional Revive Application (+1)",
              "Additional Man-Hours Per Month of Maintenance Services (+2)",
            ],
            winter_features: [
              'Kick Back winter maintenance add-on options',
              '1" Threshold',
            ]
        }
    ])

    const [intallmentAmountSummer, setIntallmentAmountSummer] = useState(null)
    const [intallmentAmountWinter, setIntallmentAmountWinter] = useState(null)

    const [customerDetails, setCustomerDetails] = useState(null)

    const [selectedSummer, setSelectedSummer] = useState(defaultPackage)
    const [selectedWinter, setSelectedWinter] = useState(defaultPackage)
    
    const [billing, setBilling] = useState("monthly");
    
    const [selectedSummerPrice, setSelectedSummerPrice] = useState(0)
    const [selectedWinterPrice, setSelectedWinterPrice] = useState(0)

    const [isLoading, setIsLoading] = useState(true)

    const [fetchDealErrorMessage, setFetchDealErrorMessage] = useState(false)

    const onSubmit = async () => {
        setIsLoading(true)
        const billingFrequency = billing == 'monthly' ? 'Monthly' : 'Prepayment (5% discount)'
        const landscapePackage = packages.find(pkg => pkg.id == selectedSummer).name
        const winterPackage = packages.find(pkg => pkg.id == selectedWinter).name
        const dataToSendQuoteGenerator = {
            dealId: dealId,
            dealPipeline: '718756',  //'Residential Recurring'
            landscapePackage: landscapePackage,  //Total Freedom || Rest Easy || Kick Back
            winterPackage: winterPackage,        //Total Freedom || Rest Easy || Kick Back
            billingFrequency: billingFrequency,  //Prepayment (5% discount) || Monthly
        }

        const queryString = Object.keys(dataToSendQuoteGenerator)
            .map(key => {
            // Encode both key and value to handle special characters
            const encodedKey = encodeURIComponent(key);
            const encodedValue = encodeURIComponent(dataToSendQuoteGenerator[key]);
            return `${encodedKey}=${encodedValue}`;
            })
            .join('&');

        window.location.href = `https://proposals.acalandscape.com?${queryString}`
    }

    useEffect(() => {
        async function fetch() {
            const dealDataBE = await getDealTCM(dealId)
            console.log('dealDataBE', dealDataBE) 
            if (!dealDataBE) {
                setFetchDealErrorMessage(true)
                return
            }
            setIntallmentAmountSummer(dealDataBE.installments.summer)
            setIntallmentAmountWinter(dealDataBE.installments.winter)
            setCustomerDetails(dealDataBE.customer_details)
            setPackages(oldVal => 
                oldVal.map(pkg => {
                    const item = dealDataBE.pricing.find(el => el.name == pkg.id)
                    return {
                        ...pkg,
                        billing: item.billing
                    }
                })                
            )
            setSelectedSummerPrice(dealDataBE.pricing.find(el => el.name == defaultPackage).billing.monthly.summer)
            setSelectedWinterPrice(dealDataBE.pricing.find(el => el.name == defaultPackage).billing.monthly.winter)
            setIsLoading(false)
        }
        fetch()
    }, [])

   
    useEffect(() => {
        const winter = packages.find(pkg => pkg.id == selectedWinter).billing[billing].winter
        const summer = packages.find(pkg => pkg.id == selectedSummer).billing[billing].summer
        
        setSelectedSummerPrice(summer)
        setSelectedWinterPrice(winter)
    }, [selectedSummer, selectedWinter, billing])

    // -------- Templates -------------

    const packageCardsTemplateSummer = () => {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8 items-stretch">
            {packages.map((pkg) => {
                const isActive = selectedSummer === pkg.id;

                return (
                <button
                    key={pkg.id}
                    onClick={() => setSelectedSummer(pkg.id)}
                    className={`flex flex-col justify-start relative rounded-2xl p-5 text-left border-2 transition-all duration-200 w-full h-full
                    hover:bg-emerald-50 hover:border-emerald-400 hover:shadow-md
                    ${isActive
                        ? "border-emerald-400 bg-emerald-50 shadow-md shadow-emerald-100"
                        : "border-amber-200 bg-amber-50"
                    }`}
                >
                    {/* {pkg.badge && (
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-500 text-white text-[10px] font-bold px-3 py-1 rounded-full tracking-wider uppercase whitespace-nowrap shadow-sm">
                        {pkg.badge}
                    </span>
                    )} */}

                    <div className="flex items-start justify-between mb-3">
                    <div className="w-10 h-10 flex items-center justify-start text-3xl leading-none shrink-0">{pkg.icon}</div>
                        <div className="text-right">
                            <div className="text-xs text-gray-400 uppercase tracking-widest font-medium">{billing == 'monthly' ? '/month' : '/ season'}</div>
                            <div className="text-xl font-extrabold text-gray-900">${pkg.billing[billing].summer.toLocaleString('en-US')}</div>
                        </div>
                    </div>

                    <div className="font-semibold text-sm mb-3 text-gray-800">{pkg.name}</div>

                    <ul className="space-y-1.5">
                    {pkg.summer_features.map((summer_feature) => (
                        <li key={summer_feature} className="text-xs flex gap-2 items-start text-gray-600">
                        <span className="text-emerald-500 mt-0.5 shrink-0 font-bold">✓</span>
                        <span>{summer_feature}</span>
                        </li>
                    ))}
                    </ul>

                    {isActive && (
                    <div className="absolute inset-0 rounded-2xl ring-2 ring-emerald-400 ring-offset-1 pointer-events-none" />
                    )}
                </button>
                );
            })}
        </div>
        )
    }
    const packageCardsTemplateWinter = () => {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8 items-stretch">
                {packages.map((pkg) => {
                    const isActive = selectedWinter === pkg.id;

                    return (
                    <button
                        key={pkg.id}
                        onClick={() => setSelectedWinter(pkg.id)}
                        className={`flex flex-col justify-start relative rounded-2xl p-5 text-left border-2 transition-all duration-200 w-full h-full
                        hover:bg-emerald-50 hover:border-emerald-400 hover:shadow-md
                        ${isActive
                            ? "border-emerald-400 bg-emerald-50 shadow-md shadow-emerald-100"
                            : "border-amber-200 bg-amber-50"
                        }`}
                    >
                        {/* {pkg.badge && (
                        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-500 text-white text-[10px] font-bold px-3 py-1 rounded-full tracking-wider uppercase whitespace-nowrap shadow-sm">
                            {pkg.badge}
                        </span>
                        )} */}

                        <div className="flex items-start justify-between mb-3">
                        <div className="w-10 h-10 flex items-center justify-start text-3xl leading-none shrink-0">{pkg.icon}</div>
                            <div className="text-right">
                                <div className="text-xs text-gray-400 uppercase tracking-widest font-medium">{billing == 'monthly' ? '/month' : '/ season'}</div>
                                <div className="text-xl font-extrabold text-gray-900">${pkg.billing[billing].winter.toLocaleString('en-US')}</div>
                            </div>
                        </div>

                        <div className="font-semibold text-sm mb-3 text-gray-800">{pkg.name}</div>

                        <ul className="space-y-1.5">
                        {pkg.winter_features.map((winter_feature) => (
                            <li key={winter_feature} className="text-xs flex gap-2 items-start text-gray-600">
                            <span className="text-emerald-500 mt-0.5 shrink-0 font-bold">✓</span>
                            <span>{winter_feature}</span>
                            </li>
                        ))}
                        </ul>

                        {isActive && (
                        <div className="absolute inset-0 rounded-2xl ring-2 ring-emerald-400 ring-offset-1 pointer-events-none" />
                        )}
                    </button>
                    );
                })}
            </div>
        )
    }
    
    const customerDetailsBlock = () => {
        return (
            <>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px flex-1 bg-gray-100" />
              <span className="text-xs uppercase tracking-widest text-gray-400">Your details</span>
              <div className="h-px flex-1 bg-gray-100" />
            </div>
          
            <div className="mb-6">
              {/* Name + Address row */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-2">
                <div className="rounded-xl bg-gray-50 px-4 py-3">
                  <div className="text-sm font-medium text-gray-800 truncate">{customerDetails?.full_name}</div>
                </div>
                <div className="rounded-xl bg-gray-50 px-4 py-3">
                  <div className="text-sm font-medium text-gray-800 truncate">{customerDetails?.service_address}</div>
                </div>
              </div>
          
              {/* Areas row — single family only */}
              
                <div className="grid grid-cols-2 gap-2">
                  <div className="rounded-xl bg-gray-50 px-4 py-3">
                    <div className="text-[10px] text-gray-400 uppercase tracking-widest mb-0.5">🌨 Snow Area</div>
                    <div className="text-sm font-medium text-gray-800">{customerDetails?.snow_area} <span className="text-xs text-gray-400">sq ft</span></div>
                    <div className="text-[10px] text-gray-400 mt-1">Driveway + walkways</div>
                  </div>
                  <div className="rounded-xl bg-gray-50 px-4 py-3">
                    <div className="text-[10px] text-gray-400 uppercase tracking-widest mb-0.5">🌱 Lawn Area</div>
                    <div className="text-sm font-medium text-gray-800">{customerDetails?.lawn_area} <span className="text-xs text-gray-400">sq ft</span></div>
                  </div>
                </div>
              
            </div>
          </>
        )
    }

    const normalBlock = () => {
        return (
    <>
        { isLoading ? '' : 
            <>
            {customerDetailsBlock()}
            {/* Billing Toggle */}
            <div className="flex justify-center items-center gap-3 mb-8 p-1 bg-gray-50 rounded-xl border border-gray-100 w-full">
                {["monthly", "prepayment"].map((billing_option) => (
                    <button
                    key={billing_option}
                    onClick={() => setBilling(billing_option)}
                    className={`billing-pill px-5 py-2 rounded-lg text-sm font-medium ${
                        billing === billing_option
                        ? "bg-emerald-500 text-white text-white/70"
                        : "hover:bg-emerald-600 hover:text-white"
                    }`}
                    >
                    {billing_option === "monthly" ? "Monthly" : "Pay in Full"}
                    {billing_option === "prepayment" && (
                        <span className="ml-1.5 text-[10px] text-emerald-400 font-semibold">
                            Save 5%
                        </span>
                    )}
                    </button>
                ))}
            </div>
            {packageCardsTemplateSummer()}
            {packageCardsTemplateWinter()}
            

            {/* Totat price block */}
            <div className="mt-6 p-4 bg-gray-50 rounded-xl border border-gray-200">
                <p className="text-xs uppercase tracking-wider text-gray-400 mb-3">Total</p>

                {billing === 'prepayment' ? (
                    <div className="flex items-center justify-between">
                    <span className="text-gray-600">One-time payment</span>
                    <span className="text-xl font-bold text-gray-900">
                        ${(selectedWinterPrice + selectedSummerPrice).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                    </div>
                ) : (
                    <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <span>Summer </span>
                        <div>${selectedSummerPrice.toLocaleString('en-US')} <span className="text-gray-400">× {intallmentAmountSummer} months</span> </div>
                    </div>
                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <span>Winter </span>
                        <div>${selectedWinterPrice.toLocaleString('en-US')} <span className="text-gray-400">× {intallmentAmountWinter} months</span> </div>
                    </div>
                    <div className="border-t border-gray-200 pt-2 flex items-center justify-between">
                        <span className="text-gray-600">*1st and last months' installments due immediately to reserve your spot.</span>
                    </div>
                    </div>
                )}
                <div className="flex gap-4 m-4">
                    <Button
                        label='Back'
                        isDisabled={false}
                        onClick={previousStep}
                    />
                    <Button
                        label='Continue'
                        // isDisabled={isSaveButtonBlocked}
                        onClick={onSubmit}
                        primary
                    />
                </div>
            </div>
        </>
}
</>

        )
    }

    return (
        <div className="w-full max-w-2xl mx-auto p-4">
            <Loader isLoading={isLoading} message="Getting things ready...">
                {fetchDealErrorMessage ? 
                <div className="flex items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">
                    <XCircle className="h-5 w-5 shrink-0 text-red-500" />
                    <p className="text-sm font-medium">
                        Something went wrong while preparing pricing, please contact support.
                    </p>
                </div>
                : normalBlock()
                }
            </Loader>
        </div>
    )
}